// src/components/reports/PinButton.tsx — the home-pin control (the house glyph).
// Pin limit is 1 across the whole app, so this behaves like a radio: pinning a
// new measure replaces the previously pinned one. Parent owns pinnedId.
// Production: the tap target is bumped to 44px (the prototype's 36px tile is
// below the mobile minimum — 03_acceptance.md E).

import { C } from "../../theme";
import { RIcon } from "./reportsIcons";
import type { MeasureId } from "../../lib/reports";

export const PinButton = ({
  measureId,
  pinnedId,
  onToggle,
}: {
  measureId: MeasureId;
  pinnedId: MeasureId | null;
  onToggle: (id: MeasureId | null) => void;
}) => {
  const pinned = pinnedId === measureId;
  return (
    <button
      type="button"
      onClick={(e) => {
        e.stopPropagation();
        onToggle(pinned ? null : measureId);
      }}
      aria-pressed={pinned}
      aria-label={pinned ? "Pinned to your home page — tap to remove" : "Pin to your home page"}
      title={pinned ? "Pinned to your home page" : "Pin to your home page"}
      style={{
        width: 44,
        height: 44,
        borderRadius: 12,
        flexShrink: 0,
        cursor: "pointer",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        background: pinned ? C.brassDk : C.brassBg,
        border: `1px solid ${pinned ? C.brassDk : C.brassLt}`,
        boxShadow: pinned ? "inset 0 1px 0 rgba(255,255,255,0.25)" : "inset 0 1px 0 rgba(255,255,255,0.5)",
        transition: "all 0.15s",
        WebkitTapHighlightColor: "transparent",
      }}
    >
      <RIcon.HomePin s={18} c={pinned ? C.brassGlow : C.brassDk} sw={pinned ? 2 : 1.7} />
    </button>
  );
};
